import { Operator } from '../observable/interfaces';
import { Observable } from '../observable/observable';

export const filter =
  <T>(predicate: (value: T) => boolean): Operator<T, T> =>
  (source) =>
    new Observable((subscriber) => {
      source.subscribe((value) => {
        if (predicate(value)) {
          subscriber.next(value);
        }
      });
    });
